import { useState } from 'react';
import { faqData } from '../../../mocks/faq';

const FAQSection = () => {
  const [openId, setOpenId] = useState<number | null>(1);

  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-secondary/10 rounded-full mb-6">
            <span className="text-secondary font-semibold text-sm">Sık Sorulan Sorular</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-primary mb-6 font-heading">
            Merak Edilenler
          </h2>
          <p className="text-neutral-600 text-lg max-w-3xl mx-auto">
            2. el bilgisayar, ikinci el laptop, bilgisayar tamiri ve teknik servis hakkında sık sorulan sorular
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-4xl mx-auto space-y-4">
          {faqData.map((faq) => (
            <div
              key={faq.id}
              className="bg-white border-2 border-neutral-200 rounded-xl overflow-hidden hover:border-secondary/30 transition-colors"
            >
              <button
                onClick={() => setOpenId(openId === faq.id ? null : faq.id)}
                className="w-full flex items-center justify-between p-6 text-left cursor-pointer"
              >
                <h4 className="text-lg font-bold text-primary pr-4">{faq.question}</h4>
                <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-secondary/10 rounded-lg">
                  <i
                    className={`${
                      openId === faq.id ? 'ri-subtract-line' : 'ri-add-line'
                    } text-secondary text-xl transition-transform`}
                  ></i>
                </div>
              </button>
              {openId === faq.id && (
                <div className="px-6 pb-6">
                  <p className="text-neutral-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;